import { render, staticRenderFns } from "./CopyStakeAiStreamersTable.vue?vue&type=template&id=9542ed6a&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamersTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamersTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAiStreamersTable.vue?vue&type=style&index=0&id=9542ed6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9542ed6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
